import { render } from "./AssociationModal.vue?vue&type=template&id=38a3180b&scoped=true"
import script from "./AssociationModal.vue?vue&type=script&lang=js"
export * from "./AssociationModal.vue?vue&type=script&lang=js"

import "./AssociationModal.vue?vue&type=style&index=0&id=38a3180b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a3180b"]])

export default __exports__